import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import {Route, Routes} from "react-router-dom";
import {getUser} from "../../services/User/reducer";
import SingleStoreMultistorePage from "../Multistore/pages/Store/SingleStoreMultistorePage";
import {ConfigApi, MultistoreLayoutType} from "../../services/Api/types";
import LoginLayout from "../Login/LoginLayout";
import {PlaceProvider} from "../../services/Place/PlaceContext";
import MultistoreListPage from "../Multistore/pages/List/MultistoreListPage";
import MultistoreHomePage from "../Multistore/pages/HomePage/MultistoreHomePage";
import StoreUtils from "../../services/Store/StoreUtils";
import MultistoreMapPage from "../Multistore/pages/Map/MultistoreMapPage";
import RulesPage from "../Rules/RulesPage";
import NavbarMulti from "../../components/Navbar/NavbarMulti";

interface OwnProps {
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MultistoreContextPage = (props: Props) => {
    const layoutType = StoreUtils.getMultistoreLayoutType(props.config);

    return (
        <PlaceProvider>
            <Routes>
                <Route path={`login/*`} element={<LoginLayout/>}/>
                {
                    !layoutType && (
                        <>
                            <Route path="map" element={<MultistoreMapPage config={props.config}/>}/>
                            <Route path="list" element={<MultistoreListPage config={props.config}/>}/>
                        </>
                    )
                }
                {
                    layoutType === MultistoreLayoutType.HOME_WITH_MAP && (
                        <Route path="map" element={<MultistoreMapPage config={props.config}/>}/>
                    )
                }
                <Route path={``} element={<MultistoreHomePage config={props.config}/>}/>
                <Route path={`:storeId/*`} element={<SingleStoreMultistorePage/>}/>
                <Route path={`rules`} element={
                    <>
                        <NavbarMulti config={props.config}/>
                        <RulesPage config={props.config}/>
                    </>
                }/>
            </Routes>
        </PlaceProvider>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);

export default connector(MultistoreContextPage);